import React, {useState, useEffect} from "react";
import AjaxFunctions from "../ajaxFunctions";
import Utils from "../utils";
import * as ToastAlert from "../components/toastAlert";
import {Button, FormControlLabel, Checkbox, FormGroup} from "@material-ui/core";
import {MultiLineTextField} from "../components/commonControls.jsx";
import {MPubCardSimple} from "../components/mPubCard";
import IncubatorAddCardTab from "../components/incubatorAddCardTab";
import SharedConstants from "../../../../shared/sharedConstants";
import Toastr from "toastr";
import EvidenceCreationPage from "../components/evidenceCreation.jsx";

export function ArpahSubmissionTab(props) {
   const [focusAreaHsf, setfocusAreaHsf] = useState();
   const [focusAreaPh, setfocusAreaPh] = useState();
   const [focusAreaSs, setfocusAreaSs] = useState();
   const [focusAreaRs, setfocusAreaRs] = useState();
   const [shortTitle, setShortTitle] = useState('');
   const [explanation, setExplanation] = useState('');
   const [currentImplementation, setCurrentImplementation] = useState('');
   const [whatIsNew, setWhatIsNew] = useState('');
   const [submissions, setSubmissions] = useState([]);

   useEffect(async () => {
      await updateSubmissions();
   }, []);

   let updateSubmissions = async () => {
      let results = await AjaxFunctions.getArpahSubmissions();
      setSubmissions(results);
   }

   let addCardToIncubator = async (idCard) => {
      Toastr.options.positionClass = 'toast-bottom-full-width';
      try {
         let result = await AjaxFunctions.addCardToEndOfPortfolio(
            props.idPortfolio,
            idCard,
            SharedConstants.CardType.Evidence,
         );

         props.getUpdatedPortfolioData();
      }
      catch(err){
         Toastr.error(err);
      }
   }

   let disableSubmitButton = () => {
      try {
         let submitBtn = document.getElementById('btnEvidenceSubmit');
         submitBtn.classList.add('disabled');
      }
      catch (e) {
         console.warn(e);
      }
   }

   let addCardFunction = async (idCard) => {
      try {
         await AjaxFunctions.createArpahSubmission(
            focusAreaHsf, focusAreaPh, focusAreaSs, focusAreaRs, shortTitle,
            explanation, currentImplementation, whatIsNew, idCard
         )
         await addCardToIncubator(idCard);
         alert('Thank you. Your submission has been received and will be reviewed.');
         //setfocusAreaHsf(false);
         //setfocusAreaPh(false);
         //setfocusAreaSs(false);
         //setfocusAreaRs(false);

         setShortTitle('');
         setExplanation('');
         setCurrentImplementation('');
         setWhatIsNew('');

         let submitBtn = document.getElementById('btnEvidenceSubmit');
         submitBtn.classList.remove('disabled');
      }
      catch(err){
         Toastr.error(err);
      }
   }

   let focusAreaSelected = focusAreaHsf || focusAreaPh | focusAreaSs || focusAreaRs;
   let canSubmit =
      focusAreaSelected && shortTitle.length > 0 && explanation.length > 0 && currentImplementation.length > 0 &&
      whatIsNew.length > 0;


   return (
      <div id={'arpahSubmissionTab'}>

         {
            submissions.length > 0 &&
            <div>
               You have submitted {submissions.length} entries. The associated evidence is found in the Evidence tab.
            </div>
         }
         {
            submissions.map(x => {
               return(
                  <div className={'entry'}>
                     <div>{x.shortTitle}</div>
                  </div>
               )
            })
         }

         <div className={'header'}>
            The submission period for the ARPA-H Dash is now closed.
            Submissions selected for inclusion in the brackets will be published and open for voting on Monday,
            April 17, 2023, at 8 am EDT.
         </div>

         <div className={'submission-question-body'}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dQVQHck-LM8" title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen>
            </iframe>
            <br />
            <iframe
               src={'https://arpa-h.gov/assets/files/ARPA-H_Dash_22_March_2023.pdf#view=fitW&navpanes=0'}
               title="testPdf"
               width="600"
               height="400"
            />

            <div className={'header'}>
               Create New Submission in Six Easy Steps
            </div>
            <div className={'subheader'}>
               1. Which focus area best fits your transformation? You can choose more than one.
            </div>
            <div id={'arpahSubmissionTabCheckboxes'}>
               <div className={'form-item'}>
                  <Checkbox color={'primary'}
                            onChange={e => setfocusAreaHsf(e.target.checked)}
                  />
                  <a href={'https://stage.arpa-h.gov/research/'} target={'_blank'}>
                     Health Science Futures
                  </a>
               </div>
               <div className={'form-item'}>
                  <Checkbox
                     color={'primary'}
                     onChange={e => setfocusAreaPh(e.target.checked)}
                  />
                  <a href={'https://stage.arpa-h.gov/research/'} target={'_blank'}>
                     Proactive Health
                  </a>
               </div>
               <div className={'form-item'}>
                  <Checkbox
                     color={'primary'}
                     onChange={e => setfocusAreaSs(e.target.checked)}
                  />
                  <a href={'https://stage.arpa-h.gov/research/'} target={'_blank'}>
                     Scalable Solutions
                  </a>
               </div>
               <div className={'form-item'}>
                  <Checkbox
                     color={'primary'}
                     onChange={e => setfocusAreaRs(e.target.checked)}
                  />
                  <a href={'https://stage.arpa-h.gov/research/'} target={'_blank'}>
                     Resilient Systems
                  </a>
               </div>
            </div>
            <MultiLineTextField
               data={shortTitle}

               label="2. Provide a short title for your Submission to show in the bracket."
               onChange={(e) => setShortTitle(e.target.value)} maxLength='25' rows={`1`}
            />
            <MultiLineTextField
               data={explanation}
               label="3. Explain what transformation you are proposing. Articulate your objectives using absolutely no jargon."
               onChange={e => setExplanation(e.target.value)} maxLength='200' rows={`3`}
            />
            <MultiLineTextField
               data={currentImplementation}
               label="4. Explain how is it done today, and what the limits of the current practice are."
               onChange={e => setCurrentImplementation(e.target.value)} maxLength='200' rows={`3`}
            />
            <MultiLineTextField
               data={whatIsNew}
               label="5. Articulate what is new in your approach and why you think it will be successful and transformational."
               onChange={e => setWhatIsNew(e.target.value)} maxLength='200' rows={`3`}
            />
            <div className={'body-text'}>
               6. To support the previous question, attach a piece of formatted Evidence that strengthens
               your Bracket Entry. Make sure to provide a good Evidence statement that captures the fact from the cited work that is
               critical to successfully achieving the proposed transformation. The citation should be from a source published after
               January 1, 2018.
            </div>
            <EvidenceCreationPage
               onCreateBegin={() => {
                  disableSubmitButton();
               }}
               onCreate={(idCard) => {
                  //setCreateCardOpen(false);
                  addCardFunction(idCard);
               }}
               headerText={'Add Supporting Evidence'}
               hideAddToIncubator
               externalRequirementsNotMet={!canSubmit}
            />
         </div>



      </div>
   )
}